export class MapLocation{
    constructor(){
        this.Lat = 0;
        this.Lng = 0;
    }

    Lat: number;
    Lng: number;
}